//PrintMap.tsx =================================================
import "../Util/Prototypes";

import * as GraLay from "../Util/GraLay";
import * as MainMap from "../MainMap";
import * as PrintMap from "./PrintMap";
import * as PrintUI from "./PrintUI";
import * as Settings from "../Settings";
import * as SnackBar from "../Util/SnackBar";
import * as Util from "../Util/Util";

type printLayout = "map-only" | "a3-landscape" | "a3-portrait" | "a4-landscape" | "a4-portrait" | "letter-ansi-a-landscape" | "letter-ansi-a-portrait" | "tabloid-ansi-b-landscape" | "tabloid-ansi-b-portrait";
let pw: Window;

export function print(format: PrintUI.exportFormatType2D) {

   //Open print window first thing so popup blocker will not block it.
   if (pw) {
      if (!pw.closed) {
         if (pw.close) {
            pw.close();
         }
      }
   }

   pw = window.open("Print/Loading.html");
   if (!pw) {
      const msg = "Export pop-up window blocked. Please allow pop-ups for this site.";
      SnackBar.show(msg, 9);
      Util.errMsg(msg);
      return;
   }

   //Create export image.
   import("@arcgis/core/rest/support/PrintTemplate").then(({ default: PrintTemplate }) => {
      import("@arcgis/core/rest/support/PrintParameters").then(({ default: PrintParameters }) => {
         import("@arcgis/core/rest/print").then((PrintTask) => {

            PrintMap.setBusy(true);
            GraLay.temp.visible = false;

            let mapTitle = PrintUI.mapTitle;
            if (mapTitle === "") {
               mapTitle = Settings.print.title;
            }

            const ps = PrintUI.paperSize;
            let paperSize: printLayout;
            let dpi = Settings.print.dpi;

            if (PrintUI.portrait) {
               if (ps.Contains("Letter")) {
                  paperSize = "letter-ansi-a-portrait";

               } else if (ps.Contains("Tabloid")) {
                  dpi = 192; //Don't allow high dpi for large prints.
                  paperSize = "tabloid-ansi-b-portrait";

               } else { //Larger sizes are not supported for export yet.
                  dpi = 192; //Don't allow high dpi for large prints.
                  paperSize = "tabloid-ansi-b-portrait";
               }

            } else {
               if (ps.Contains("Letter")) {
                  paperSize = "letter-ansi-a-landscape";

               } else if (ps.Contains("Tabloid")) {
                  dpi = 192; //Don't allow high dpi for large prints.
                  paperSize = "tabloid-ansi-b-landscape";

               } else { //Larger sizes are not supported for export yet.
                  dpi = 192; //Don't allow high dpi for large prints.
                  paperSize = "tabloid-ansi-b-landscape";
               }
            }

            //Util.errMsg("PrintMap.mapScale: " + PrintMap.mapScale.toString() + " DPI: " + dpi);

            const template = new PrintTemplate({
               format: format,
               layout: paperSize,
               scalePreserved: true,
               outScale: PrintMap.mapScale,
               exportOptions: { dpi: dpi },
               layoutOptions: {
                  titleText: mapTitle,
                  copyrightText: Settings.print.disclaimer,
                  scalebarUnit: "Miles",
                  legendLayers: [],
               }
            });

            if ((PrintMap.mapScale / 12) < 2640) {
               template.layoutOptions.scalebarUnit = "Feet";
            }

            const params = new PrintParameters({
               view: MainMap.mapView,
               template: template,
               outSpatialReference: MainMap.activeView.spatialReference,
            });

            PrintMap.toggleBlackParcelLines(false); //Turn off hover layers before printing.

            //Util.logMsg("Params: ", params);
            //Util.logMsg("MapView: ", MainMap.mapView);
            PrintTask.execute(Settings.printService_URL, params).then(printResult).catch(printError);

         }); //end import print task.
      }); //end import printParameters.
   }); // end import printTemplate.
}

function printResult(results: __esri.PrintResponse) {
   PrintMap.setBusy(false);
   PrintMap.toggleBlackParcelLines(true); //Turn hover layers back on.
   GraLay.temp.visible = true;
   pw.location.replace(results.url);
   pw.focus();
}

//Print task failed.
function printError(error: Error) {
   PrintMap.setBusy(false);
   PrintMap.toggleBlackParcelLines(true); //Turn hover layers back on.
   GraLay.temp.visible = true;
   SnackBar.show("Error creating map image", 3);
   Util.errMsg("Error creating map image", error);
}
